export default __webpack_public_path__ + "static/media/utp16.53a75349.jpg";